export default "//cdn.scentbird.com/assets/frontbird-site/images/sunCare_0c709c.png";